import React, { FunctionComponent } from 'react';
import { DialogContentText } from '@mui/material';

import { Dialog } from '@paragon/popup-state';

interface ConfirmDialogProps {
  title: string;
  message: string;
  open: boolean;
  cancelText?: string;
  onClose: (result: boolean) => void;
}

export const ConfirmDialog: FunctionComponent<ConfirmDialogProps> = (props) => (
  <Dialog
    insistent
    variant="design"
    title={props.title}
    onSubmit={() => props.onClose(true)}
    onCancel={() => props.onClose(false)}
    cancelText={props.cancelText}
  >
    <DialogContentText>{props.message}</DialogContentText>
  </Dialog>
);
